// extracted by mini-css-extract-plugin
export default {"container":"audio__container__oU5yh","muted":"audio__muted__NwSP_","soundOn":"audio__soundOn__txc8D","hide":"audio__hide__FZTMo"};